import { IGpt } from "Interfaces/Gpt";
import {useGptContext} from "./GptContext.hook";

export interface IGptContextState {
    loaded: boolean,
    list: Array<IGpt>,
}

export type IGptContext = ReturnType<typeof useGptContext>;

/////////////////////////////////////////////////////// REDUCER ///////////////////////////////////////////////////////

export enum GptContextDispatchMessageType {
    SetList, SetLoaded 
}

type SetList = {
    type: GptContextDispatchMessageType.SetList,
    list: Array<IGpt>
};

type SetLoaded = {
    type: GptContextDispatchMessageType.SetLoaded,
    value: boolean,
}

export type GptContextDispatchMessage = SetList | SetLoaded
